module.exports = __webpack_public_path__ + "img/eye-protect-system.24f73fe4.jpg";